import { render, staticRenderFns } from "./OscillationGuard.vue?vue&type=template&id=972c7aa8&scoped=true"
import script from "./OscillationGuard.vue?vue&type=script&lang=js"
export * from "./OscillationGuard.vue?vue&type=script&lang=js"
import style0 from "./OscillationGuard.vue?vue&type=style&index=0&id=972c7aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972c7aa8",
  null
  
)

export default component.exports